import React from 'react';
import { Button, Card, CardBody,Input } from 'reactstrap';
import { useSpecimens } from '../../hooks/specimens/useSpecimens';
import { RibbonSpecimen } from '../../constant';
import { TableStriped } from '../../components/tables/TableStriped';
import { ModalSpecimens } from '../../components/specimens/ModalSpecimens';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
export const IndexSpecimen = ({activeTab}) => {

    const {
        specimens, method,
        handleInputChange, validaciones,
        name, abbreviation,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        modalAlert, showDeleteAlert, closeDeleteAlert,
        loadingExcel, handleExcelSpecimens,
        handleClearSpecimen, searchSpecimen, handleSearchSpecimen

    } = useSpecimens({activeTab});

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_specimen)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_specimen)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <>
            <Card>
                <CardBody className="p-1 mt-2">
                    <TitleDataTable
                        titleTable="Listado de tipos de especimen"
                        buttonActions={handleExcelSpecimens}
                        titleButton="Listado de tipos de"
                        isDisbled={loadingExcel}
                        loadingIsDisabled={loadingExcel}
                        titleCreate="Crear listado de especimen"
                        buttonActionsCreate={handleCreate}
                        actionInput={handleSearchSpecimen}
                        valueFilter={searchSpecimen}
                        filterLocalStorage={true}
                        cleanFilterLocalStorage={handleClearSpecimen}
                    />
            
                    <div className="table-responsive">
                        <DataTable
                            value={specimens}
                            paginator
                            rows={15}
                            responsiveLayout="scroll"
                            rowsPerPageOptions={[15, 50, 100]} 
                            className="data-table p-datatable-striped p-datatable-sm"
                            emptyMessage={
                                <div className="text-center">
                                    <img
                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                        style={{ width: "32%" }}
                                        alt="Sin resultados"
                                    />
                                    <br />
                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                        No se encontraron resultados.
                                    </p>
                                </div>
                            }
                        >

                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                            <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="abbreviation" header="Abreviatura" headerStyle={headerStyle} style={cellStyle} />
                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                        </DataTable>
                    </div>
                   

                </CardBody>
            </Card>

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar especímen"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el especímen:?"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />

            )}
            
            <ModalSpecimens
                {
                    ...{
                        modal, modalTitle, closeDialog, method, loading,
                        name, abbreviation, handleInputChange,
                        validaciones, saveCreate, saveUpdate, saveDelete
                    }
                }
            />
        </>
    )
}
